class Auth {
  constructor() {
    this.authenticated = false;
  }

  login() {
    if (
      localStorage.getItem("token") !== null ||
      localStorage.getItem("token") !== "" ||
      localStorage.getItem("token") !== undefined
    ) {
      this.authenticated = true;
    }
  }

  logout() {
    this.authenticated = false;
  }

  isAuthenticated() {
    return this.authenticated;
  }
}

const auth = new Auth();
export default auth;
